import { render, staticRenderFns } from "./ztgytab.vue?vue&type=template&id=0eb4fb83&"
import script from "./ztgytab.vue?vue&type=script&lang=js&"
export * from "./ztgytab.vue?vue&type=script&lang=js&"
import style0 from "./ztgytab.vue?vue&type=style&index=0&id=0eb4fb83&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports